import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Nav from './components/Nav';
import Home from './pages/Home';
import About from './pages/About';
import Packages from './pages/Packages';
import Testimonials from './pages/Testimonials';
import FAQ from './pages/FAQ';
import PasswordGate from './components/PasswordGate';
import './styles/global.css';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function AppRoutes() {
  return (
    <>
      <ScrollToTop />
      <Nav />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/faq" element={<FAQ />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <PasswordGate>
        <AppRoutes />
      </PasswordGate>
    </BrowserRouter>
  );
}
